import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Translate, { TranslateProps } from 'client/components/translate';
import 'client/styles/strideTip.scss';

const propTypes = {
  description: TranslateProps,
  planUrl: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.element,
  agencyName: PropTypes.string,
};

const defaultProps = {
  description: null,
  onClick: () => {},
  planUrl: '',
  children: null,
  agencyName: '',
};

export default class StrideTip extends PureComponent {
  render() {
    const { description, planUrl, onClick, children, agencyName } = this.props;

    return (
      <div className="stride-tip text-center grey-2-color">
        {description && (
          <div className="description pad">
            <h4>
              <Translate path="common.strideTip.title" using={{ agencyName }} />
            </h4>
            <Translate className="light" {...description} />
          </div>
        )}
        {children}
        {planUrl.length > 0 && (
          <div className="more-info pad">
            <div>
              <Translate path="common.strideTip.moreInfo" />
            </div>
            <a
              href={planUrl}
              rel="noopener noreferrer"
              target="_blank"
              onClick={onClick}
              style={{ fontWeight: 'bold' }}>
              <Translate path="common.strideTip.viewSummary" />
            </a>
          </div>
        )}
      </div>
    );
  }
}

StrideTip.propTypes = propTypes;
StrideTip.defaultProps = defaultProps;
